import { FC } from 'react';
import { Shining, ShiningProps } from './shining';
import Image, { ImageProps } from 'next/image';

type SuperstarShiningProps = Omit<ShiningProps, 'children'> & {
  imageUrl: string;
  imageProps?: Omit<ImageProps, 'src'>;
};
export const SuperstarShining: FC<SuperstarShiningProps> = ({
  imageUrl,
  imageProps,
  ...props
}) => {
  return (
    <Shining {...props} asChild>
      <div className="absolute inset-0">
        <Image
          {...imageProps}
          src={imageUrl}
          alt={imageProps?.alt ?? 'Superstar'}
        />
      </div>
    </Shining>
  );
};
